import React, { useState, useEffect } from 'react';
import './UpdateBanner.css';  // Create this CSS file for styling

const UpdateBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  // Check if the banner has already been dismissed
  useEffect(() => {
    const dismissed = localStorage.getItem('mojieLiveBannerDismissed');
    if (!dismissed) {
      setShowBanner(true);  // Show banner if not dismissed
    }
  }, []);

  // Dismiss the banner and store the dismissal in localStorage
  const dismissBanner = () => {
    setShowBanner(false);
    localStorage.setItem('mojieLiveBannerDismissed', 'true');
  };

  if (!showBanner) return null;  // Return null if the banner is dismissed

  return (
    <div className="update-banner">
      <div className="update-banner-content">
        <p>🚨 Mojie is live again! 🎉</p>
        <button className="dismiss-btn" onClick={dismissBanner} aria-label="Dismiss banner">×</button>
      </div>
    </div>
  );
};

export default UpdateBanner;
